/* ============================================================
   VIVĀRA — CLAIMS REGISTER
   ------------------------------------------------------------
   Every wellness, performance, sourcing, extraction and quality
   claim the site could make is registered here with a status.

     status: "approved"  → rendered on the site
     status: "pending"   → NOT rendered; awaiting substantiation

   Nothing with status "pending" reaches the page. To publish a claim,
   supply the substantiation, set status to "approved" and the copy
   appears wherever that key is consumed — no markup changes needed.

   None of this language may state or imply that Element 003 diagnoses,
   treats, cures or prevents any disease.

   SHOPIFY MIGRATION
   -----------------
   This maps to product metafields (namespace `claims`) so legal can
   manage approvals without touching theme code.
   ============================================================ */
(function () {
  "use strict";

  window.VIVARA_CLAIMS = {
    /* ---- product benefit list (product page) ------------------------
       Approved by the brand owner and supplied as finished artwork
       ("The Benefits of Shilajit", Element 003 product plate).

       Two labels differ from the supplied artwork, on purpose. "Reduces
       stress" and "Improves cognition and memory" assert an outcome, which
       is a disease/treatment register the FDA does not permit for a dietary
       supplement without approval. The wording below keeps the same meaning
       inside structure/function language, which is what a supplement may say
       alongside the FDA disclaimer carried in the footer:

         Reduces stress                 → Supports a calm response to stress
         Improves cognition and memory  → Supports cognitive function and memory

       Everything here still needs substantiation on file before launch —
       correct phrasing is not the same as evidence. */
    benefits: [
      { key: "adaptogenic",   label: "Adaptogenic",                              status: "approved" },
      { key: "stress",        label: "Supports a calm response to stress",       status: "approved" },
      { key: "energy",        label: "Supports increased energy",                status: "approved" },
      { key: "detox",         label: "Supports detoxification",                  status: "approved" },
      { key: "fulvic",        label: "Rich in fulvic acid and trace minerals",   status: "approved" },
      { key: "cognition",     label: "Supports cognitive function and memory",   status: "approved" },
      { key: "cellular",      label: "Supports healthy cellular function",       status: "approved" }
    ],

    /* ---- composition ------------------------------------------------
       "84+ trace minerals" and "most bioavailable" are withdrawn.
       The educational statement below is factual about shilajit as a
       material and makes no claim about Element 003's effects. */
    education: {
      status: "approved",
      text: "Shilajit is a mineral-rich resin containing a broad spectrum of naturally " +
            "occurring trace minerals, humic substances, and fulvic acid."
    },

    /* ---- sourcing and process --------------------------------------
       Exact coordinates, altitude band, "cold extracted", "preserves the
       full spectrum" and purification specifics are held until the
       supplier documentation is supplied. */
    sourcing: {
      region:      { status: "approved", label: "Region",  value: "Karakoram Range" },
      country:     { status: "approved", label: "Country", value: "Northern Pakistan" },
      harvest:     { status: "approved", label: "Harvest", value: "Wild-harvested at altitude" },
      method:      { status: "approved", label: "Method",  value: "Traditional knowledge, modern methods" },

      coordinates: { status: "pending",  label: "Coordinates", value: null },
      altitude:    { status: "pending",  label: "Altitude",    value: null },
      extraction:  { status: "pending",  label: "Extraction",  value: null },
      purity:      { status: "pending",  label: "Purity",      value: null }
    },

    /* ---- testing ----------------------------------------------------
       No badge, seal or testing statement may appear until current
       documentation is on file. */
    testing: {
      thirdParty:          { status: "pending", value: null },
      certificateOfAnalysis: { status: "pending", url: null },
      heavyMetals:         { status: "pending", value: null },
      microbial:           { status: "pending", value: null },
      batchNumber:         { status: "pending", value: null }
    },

    /* Helper: return only approved entries from a list. */
    approved: function (list) {
      return (list || []).filter(function (c) { return c.status === "approved"; });
    },

    /* Helper: is a single claim publishable? */
    ok: function (claim) {
      return !!claim && claim.status === "approved" && claim.value != null;
    }
  };

  /* ---------- rendering ----------
     [data-claims="benefits"] fills with approved benefit claims only.
     With none approved the list — and any element marked
     [data-claims-empty-remove] — is removed rather than left empty. */
  function paint() {
    var C = window.VIVARA_CLAIMS;

    document.querySelectorAll('[data-claims="benefits"]').forEach(function (host) {
      var list = C.approved(C.benefits);
      if (!list.length) {
        document.querySelectorAll("[data-claims-empty-remove]").forEach(function (n) { n.remove(); });
        host.remove();
        return;
      }
      host.innerHTML = "";
      list.forEach(function (c, i) {
        var li = document.createElement("li");
        li.setAttribute("data-reveal", "");
        var n = document.createElement("span");
        n.className = "pp-benefit-n";
        n.textContent = ("0" + (i + 1)).slice(-2);
        var h = document.createElement("h3");
        h.className = "pp-benefit-label";
        h.textContent = c.label;
        li.appendChild(n);
        li.appendChild(h);
        host.appendChild(li);
      });
    });

    /* Sourcing data rows render only where the claim is approved. */
    document.querySelectorAll("[data-claim-sourcing]").forEach(function (el) {
      var claim = C.sourcing[el.getAttribute("data-claim-sourcing")];
      if (!C.ok(claim)) el.remove();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", paint);
  } else {
    paint();
  }
})();
